import { Label } from '@fluentui/react';
import { List } from 'office-ui-fabric-react';
import { DefaultButton, IconButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { Checkbox } from 'office-ui-fabric-react/lib/Checkbox';
import { SelectionMode } from 'office-ui-fabric-react/lib/DetailsList';
import React, { Component, Fragment } from 'react';
import Scriba from 'react-scriba';
import PerimetreContext from '../../contexts/PerimetreContext';
import { DataContratDeReservation } from '../../data/DataContratDeReservation';
import { DataDocument } from '../../data/DataDocument';
import { Immocom } from '../../specifique/immocom';
import { EUIDetailsList } from '../EUI/EUIDetailsList';
import { EUIDialog } from '../EUI/EUIDialog';
import { EUIPanel } from '../EUI/EUIPanel';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../Outils/MessageBars';

export class DetailsListContratDeReservation extends Component {
    static contextType = PerimetreContext;
    render = () => {
        const { perimetre } = this.context;
        return <DetailsListContratDeReservationWithPerimetre {...this.props} perimetre={perimetre} />;
    };
};

class DetailsListContratDeReservationWithPerimetre extends Component {

    static defaultProps = {
        perimetre: {}
    };

    static defaultState = {
        items: [],
        itemsSelectionnes: [],
        /* --- */
        pageIndex: 1,
        facteurNbreEnregistrement: 100,
    };

    constructor(props) {
        super(props);
        this.state = { ...DetailsListContratDeReservationWithPerimetre.defaultState };
        this._columns = this._getColumns();
        this._filtres = this._getFiltres();
        this._isSortedDescending = false;
        this._sortedColumn = "region";
    };

    _chargementDonnees = () => {

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Chargement des contrats en cours..."
        });

        const { facteurNbreEnregistrement, pageIndex } = this.state;
        const tri = `${this._sortedColumn} ${this._isSortedDescending ? "DESC" : "ASC"}`;

        DataContratDeReservation._chargementContratsDeReservations(this._filtres, tri, facteurNbreEnregistrement, pageIndex).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                const objetData = responseFetch.reponseAPIobjet;
                const newItems = objetData || [];

                let items = [];
                if (pageIndex === 1) items = newItems;
                else {
                    items = [...this.state.items];
                    items = items.concat(newItems);
                }

                const state = { items };
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, state);
            }
            else Immocom.onTraitementErreurAvecState(this, { items: [] }, retourVerif, responseFetch);
        });

    };

    _appliquerFiltres = (filtres) => {
        this._filtres = { ...filtres };
        this.setState({
            afficherPanelFiltres: false,
            pageIndex: 1
        }, this._chargementDonnees);
    };

    _getColumns = () => {
        return [{
            key: "region",
            minWidth: 75,
            maxWidth: 100,
            name: "Région",
        }, {
            className: "ms-hiddenMdDown",
            headerClassName: "ms-hiddenMdDown",
            key: "agence",
            minWidth: 75,
            maxWidth: 150,
            name: "Agence",
        }, {
            key: "nomCommercial",
            name: "Opération",
        }, {
            key: "nomClient",
            minWidth: 100,
            maxWidth: 200,
            name: "Clients",
        }, {
            key: "numero",
            minWidth: 50,
            maxWidth: 50,
            name: "N° lot",
        }, {
            className: "ms-hiddenMdDown text-right",
            headerClassName: "ms-hiddenMdDown text-right",
            key: "prixHT",
            minWidth: 75,
            maxWidth: 75,
            name: "Prix Grille HT",
            onRender: (item) => {
                const prixHT = item.prixHT ? `${Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(parseFloat(item.prixHT).toFixed(2), false, 2)} €` : "";
                return <span title={prixHT}>{prixHT}</span>;
            }
        }, {
            className: "ms-hiddenMdDown text-right",
            headerClassName: "ms-hiddenMdDown text-right",
            key: "prixVenteHT",
            minWidth: 100,
            maxWidth: 100,
            name: "Prix de vente HT",
            onRender: (item) => {
                const prixVenteHT = item.prixVenteHT ? `${Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(parseFloat(item.prixVenteHT).toFixed(2), false, 2)} €` : "";
                return <span title={prixVenteHT}>{prixVenteHT}</span>;
            }
        }, {
            className: "ms-hiddenLgDown",
            headerClassName: "ms-hiddenLgDown",
            key: "nomDocument",
            minWidth: 200,
            maxWidth: 300,
            name: "Document",
        }, {
            className: "ms-hiddenXlDown",
            headerClassName: "ms-hiddenXlDown",
            key: "typeDocument",
            minWidth: 150,
            maxWidth: 150,
            name: "Type de document",
        }, {
            className: "ms-hiddenMdDown",
            headerClassName: "ms-hiddenMdDown",
            key: "dateSignatureElectronique",
            name: "Date signature",
        }, {
            isIconOnly: true,
            key: "telecharger",
            onRender: (item) => {
                return <IconButton
                    iconProps={{ iconName: "DownloadDocument" }}
                    onClick={this._telechargerContrat(item)}
                    title="Télécharger le contrat"
                />;
            }
        }, {
            isIconOnly: true,
            key: "signer",
            onRender: (item) => {
                return <IconButton
                    disabled={item.signeEiffage}
                    iconProps={{ iconName: "InsertSignatureLine" }}
                    onClick={this._toggleDialogSignature(true, item)}
                    title="Signer le contrat"
                />;
            }
        }];
    };

    _getFiltres = () => {
        return { ...PanelFiltres.defaultState };
    };

    _getItems = () => {
        return [{
            disabled: this.state.itemsSelectionnes.length === 0,
            key: "signature",
            name: "Signer les réservations",
            iconProps: { iconName: "InsertSignatureLine" },
            onClick: this._toggleDialogSignature(true)
        }];
    };

    _onColumnHeaderClick = (sortedColumn, isSortedDescending) => {
        this._sortedColumn = sortedColumn;
        this._isSortedDescending = isSortedDescending;
        this.setState({ pageIndex: 1 }, this._chargementDonnees);
    };

    _onScroll = () => {
        this.setState(
            prevState => ({ pageIndex: prevState.pageIndex + 1 }),
            this._chargementDonnees
        );
    };

    _onSearch = (keyword) => {
        this._filtres.recherche = keyword;
        this.setState({ pageIndex: 1 }, this._chargementDonnees);
    };

    _signerContrats = () => {

        this._toggleDialogSignature(false)();

        const { itemsSelectionnes } = this.state;

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Signature en cours..."
        });

        let listeDesPromisesAExecuter = [];
        itemsSelectionnes.forEach((contrat, index) => {
            const { idReservation, idOperation, rowGUID } = contrat;
            const promise = DataContratDeReservation._signatureContratDeReservation(idReservation, idOperation, rowGUID);
            listeDesPromisesAExecuter.push(promise);
        });

        Promise.all(listeDesPromisesAExecuter).then(responsePromise => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responsePromise, this);
            if (retourVerif === null)
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, {}, this._chargementDonnees);
            else Immocom.onTraitementErreurPromise(this, retourVerif);
        });

    };

    _telechargerContrat = (item) => () => {

        const { rowGUID } = item;

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Téléchargement du contrat..."
        });

        DataDocument._onTelechargementDocument(rowGUID).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                const objetData = responseFetch.reponseAPIobjet;
                const document = Scriba.fichier().Base64VersByteArray(objetData.fileData);
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, {}, true);
                return Scriba.fichier().EnregisterSous(document, objetData.nom);
            }
            else Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
        });

    };

    _toggleDialogSignature = (isOpen, contrat) => () => {
        this.setState(prevState => ({
            afficherDialogSignature: isOpen,
            itemsSelectionnes: contrat ? [contrat] : prevState.itemsSelectionnes
        }));
    };

    _togglePanelFiltres = (isOpen) => () => {
        this.setState({ afficherPanelFiltres: isOpen });
    };

    //componentDidUpdate = () => {
    //    if (localStorage.getItem("onRecharge") === "true") {
    //        localStorage.setItem("onRecharge", "false");
    //        this.setState({ pageIndex: 1 }, this._chargementDonnees);
    //    }
    //};

    componentDidUpdate = (prevProps) => {
        const { perimetre } = this.props;
        if (JSON.stringify(prevProps.perimetre) !== JSON.stringify(perimetre))
            this.setState({ pageIndex: 1 }, this._chargementDonnees);
    };

    render = () => {

        const { afficherPanelFiltres, afficherDialogSignature, items, itemsSelectionnes } = this.state;

        return <Fragment>

            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

            <MessageBars
                errorMessage={this.state.errorMessage}
                infoMessage={this.state.messageMessageBarFiltres}
                warningMessage={this.state.warningMessage}
                onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
            />

            <EUIDetailsList
                canSelectItem={item => !item.signeEiffage}
                columns={this._columns}
                getKey={item => `${item.idOperation};${item.idReservation}`}
                isSortedDescending={this._isSortedDescending}
                items={items}
                menuItems={this._getItems()}
                onColumnHeaderClick={this._onColumnHeaderClick}
                onFilterButtonClick={this._togglePanelFiltres(true)}
                onScroll={this._onScroll}
                onSearch={this._onSearch}
                onSelectionChanged={items => this.setState({ itemsSelectionnes: items })}
                selectionMode={SelectionMode.multiple}
                sortedColumn={this._sortedColumn}
            />

            <PanelFiltres
                filtres={{ ...this._filtres }}
                isOpen={afficherPanelFiltres}
                onDismiss={this._togglePanelFiltres(false)}
                onValidate={this._appliquerFiltres}
            />

            <EUIDialog
                buttons={[
                    <PrimaryButton key="confirm" onClick={this._signerContrats} text="Confirmer" />,
                    <DefaultButton key="cancel" onClick={this._toggleDialogSignature(false)} text="Annuler" />
                ]}
                isOpen={afficherDialogSignature}
                onDismiss={this._toggleDialogSignature(false)}
                titre="Signature électronique"
            >
                <div>Confirmez-vous la signature électronique du ou des contrats de réservations listé(s) ci-dessous ?</div>
                <List
                    className="py-1"
                    items={itemsSelectionnes}
                    onRenderCell={(contrat, index) => <div key={index}>•&nbsp;{contrat.nomDocument}</div>}
                />
            </EUIDialog>

        </Fragment>;

    };

};

class PanelFiltres extends Component {

    static defaultProps = {
        filtres: {},
        isOpen: false,
        /* --- */
        onDismiss: () => null,
        onValidate: () => null,
    };

    static defaultState = {
        afficherContratsASigner: true,
        afficherContratsSignes: false,
    };

    constructor(props) {
        super(props);
        this.state = this._getFiltresParDefaut();
    };

    _appliquerFiltres = () => {
        const filtres = { ...this.state };
        this.props.onValidate(filtres);
    };

    _getFiltresParDefaut = () => {
        const filtres = { ...PanelFiltres.defaultState };
        return filtres;
    };

    _reinitialiserFiltres = () => {
        this.setState(this._getFiltresParDefaut());
    };

    _onOpen = () => {
        this.setState({ ...this.props.filtres });
    };

    componentDidMount = () => {
        this._appliquerFiltres();
    };

    render = () => {

        const { isOpen, onDismiss } = this.props;
        const { afficherContratsASigner, afficherContratsSignes } = this.state;

        return <EUIPanel
            headerText="Filtres"
            isOpen={isOpen}
            onDismiss={onDismiss}
            onOpen={this._onOpen}
            onResetFilters={this._reinitialiserFiltres}
            onValidate={this._appliquerFiltres}
        >

            <Label>Contrats</Label>

            <Checkbox
                label="A signer"
                checked={afficherContratsASigner}
                onChange={(e, isChecked) => this.setState({ afficherContratsASigner: isChecked })}
            />

            <Checkbox
                label="Signés"
                checked={afficherContratsSignes}
                onChange={(e, isChecked) => this.setState({ afficherContratsSignes: isChecked })}
            />

        </EUIPanel>;

    };

};